const translations = {
  fr: {
    // Common
    loading: "Chargement...",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    create: "Créer",
    close: "Fermer",
    search: "Rechercher",
    actions: "Actions",
    yes: "Oui",
    no: "Non",
    logout: "Déconnexion",
    language: "Langue",
    login: "Connexion",
    login_subtitle: "Accédez à votre espace de gestion",
    connecting: "Connexion...",
    connect: "Se connecter",
    order_management: "Gestion des commandes et du suivi",

    // Nav
    nav_dashboard: "Tableau de bord",
    nav_orders: "Commandes",
    nav_clients: "Clients",
    nav_products: "Produits",
    nav_archives: "Archives",
    nav_commercials: "Commerciaux",
    nav_partners: "Partenaires",
    nav_expenses: "Dépenses",
    nav_transport: "Transport",
    nav_settings: "Paramètres",

    // Dashboard
    dashboard_title: "Tableau de bord",
    dashboard_subtitle: "Vue d'ensemble de votre activité",
    all_companies: "Toutes les sociétés",
    monthly_sales: "Ventes mensuelles",
    france_vs_vn: "Panther France vs Vietnam",
    total_sales: "Ventes totales",
    total_costs: "Coûts totaux",
    gross_margin: "Marge brute",
    commissions: "Commissions",
    expenses: "Dépenses",
    net_profit: "Bénéfice net",
    orders_in_progress: "Commandes en cours",
    no_orders_in_progress: "Aucune commande en cours",
    change_status: "CHANGER LE STATUT",
    delivery_office: "LIV. BUREAU",
    delivery_client: "LIV. CLIENT",
    order: "Commande",
    orders_count: "commande(s)",
    client: "Client",
    country: "Pays",
    phone: "Téléphone",
    email: "Email",
    address: "Adresse",
    company: "Société",
    pieces: "Pièces",
    urgency: "Urgence",
    order_date: "Date commande",
    delivery_date_office: "Livraison bureau",
    delivery_date_client: "Livraison client",
    commercial: "Commercial",
    commission: "Commission",
    tracking_number: "N° de suivi",
    tracking_link: "Lien de suivi",
    selling_price: "Prix vente",
    margin: "Marge brute",
    status: "Statut",

    // Status translations
    "status_commandée": "COMMANDÉE",
    "status_impression": "IMPRESSION",
    "status_couture": "COUTURE",
    "status_livraison bureau": "LIVRAISON BUREAU",
    "status_en cours de livraison client": "EN COURS DE LIVRAISON CLIENT",
    "status_livrée": "LIVRÉE",

    // Urgency translations
    urgency_urgent: "Urgent",
    urgency_prioritaire: "Prioritaire",
    urgency_classique: "Classique",
    urgency_non_urgent: "Non urgent",

    // Commercial KPIs
    month_ca: "CA du mois",
    year_ca: "CA de l'année",
    month_commission: "Commission du mois",
    my_ca_commissions: "Mon CA et commissions",
    archives: "Archives",
    delivered_orders_by_month: "Commandes livrées classées par mois",

    // Orders page
    orders_title: "Commandes",
    new_order: "Nouvelle commande",
    order_number: "N° Commande",
    search_client: "Rechercher par nom ou entreprise...",
    add_client: "Nouveau client",
    firstname: "Prénom",
    postal_code: "Code postal",
    city: "Ville",
    delivery_preview: "Prévisualisation des dates",
    order_lines: "Lignes de commande",
    add_line: "Ajouter une ligne",
    product: "Produit",
    quantity: "Quantité",
    unit_cost: "Coût unitaire",
    weight_kg: "Poids (kg)",
    unit_price: "Prix unitaire",
    subtotal: "Sous-total",
    transport_estimate: "Estimation transport",
    cost_per_kg: "Coût/kg",
    fixed_fee: "Frais fixe",
    total_weight: "Poids total",
    transport_cost: "Coût transport",
    selling_price_eur: "Prix de vente EUR",
    selling_price_vnd: "Prix de vente VND",
    profit: "PROFIT",
    sale_minus_product: "Vente - Produit",
    sale_minus_all: "Vente - Produit - Transport",
    dropbox_link: "Lien Dropbox",
    save_order: "Enregistrer la commande",
    update_order: "Mettre à jour",
    required_fields_missing: "Champs obligatoires manquants",
    images: "Images",
    add_image: "Ajouter une image",
    upload_image: "Télécharger",

    // Clients
    clients_title: "Clients",
    new_client: "Nouveau client",
    company_name: "Société",
    total_orders: "Commandes",
    total_ca: "CA total",

    // Products
    products_title: "Produits",
    new_product: "Nouveau produit",
    product_name: "Nom du produit",
    cost: "Coût",
    weight: "Poids",

    // Archives
    archives_title: "Archives",
    archives_subtitle: "Commandes livrées regroupées par mois",
    delivered_orders: "commande(s) livrée(s)",
    material_cost: "Coût matière",
    transport_cost_label: "Coût transport",
    delivery_cost: "Coût livraison",

    // Commercials
    commercials_title: "Commerciaux",
    commercials_subtitle: "Gestion des comptes commerciaux et commissions",
    new_commercial: "Nouveau commercial",
    zone: "Zone couverte",
    commission_rate: "Commission appliquée",
    weekly_recap: "Récapitulatif hebdomadaire",
    weekly_recap_subtitle: "Aperçu des performances : CA et commissions par commercial",
    week_orders: "Cmd semaine",
    week_ca: "CA semaine",
    week_commission: "Com. semaine",
    month_orders: "Cmd mois",
    month_ca_label: "CA mois",
    month_commission_label: "Com. mois",
    commissions_by_month: "Commissions par mois / année",
    commissions_by_month_subtitle: "Détail des commissions calculées automatiquement pour chaque commercial",
    months_count: "mois",

    // Partners
    partners_title: "Partenaires",
    partners_subtitle: "Gestion des accès partenaires (Imprimeur, Couture, Transport, Manager)",
    new_partner: "Nouveau partenaire",
    partner_type: "Type de partenaire",
    allowed_statuses: "Statuts autorisés",
    status_help: "Le 1er statut = ce que le partenaire voit, les suivants = ce qu'il peut appliquer",

    // Expenses
    expenses_title: "Dépenses",
    new_expense: "Nouvelle dépense",
    expense_type: "Type",
    amount: "Montant",
    description: "Description",
    currency: "Devise",

    // Transport
    transport_title: "Coûts de transport",
    transport_subtitle: "Gestion des coûts par pays",
    add_country: "Ajouter un pays",
    monthly_report: "Compte rendu mensuel - Livraisons",
    monthly_report_subtitle: "Nombre de commandes livrées par mois",
    total_delivered: "commande(s) livrée(s)",
    delivered_count: "Commandes livrées",

    // Settings
    settings_title: "Paramètres",
    eur_vnd_rate: "Taux EUR/VND",

    // Partner Dashboard
    partner_orders: "Commandes à traiter",
    partner_orders_subtitle: "en attente de votre action",
    pending_orders: "commande(s) en attente",
    no_pending_orders: "Aucune commande en attente",
    validate: "VALIDER",
    weight_label: "Poids (kg)",
    address_delivery: "Adresse de livraison",
    partner_archives: "Archives - Tâches terminées",
    partner_archives_subtitle: "commande(s) traitée(s), regroupées par mois",
    delivery_expected: "Livraison prévue",
    not_provided: "Non renseignée",

    // Partner types
    type_imprimeur: "Imprimeur",
    type_couture: "Couture",
    type_transport: "Transport",
    type_manager: "Manager",

    // Manager Dashboard
    manager_title: "Tableau de bord Manager",
    manager_subtitle: "Suivi des commandes en cours",

    // Image
    click_to_enlarge: "Cliquer pour agrandir",
    no_image: "Pas d'image",
    image_popup_title: "Images de la commande",

    // Notification
    new_order_notification: "Nouvelle commande !",
    new_orders_notification: "nouvelles commandes !",
    alert_orange_notification: "Attention : commande proche de la date limite !",
    alert_red_notification: "Urgence : commande en retard !",

    // Order detail profit
    estimated_profit: "PROFIT ESTIMÉ",
    product_cost_label: "Coût produit",
    product_lines: "lignes de produit",

    // Advanced filters
    filter_by_status: "Filtrer par statut",
    filter_by_date: "Filtrer par date",
    filter_by_commercial: "Filtrer par commercial",
    all_statuses: "Tous les statuts",
    all_commercials: "Tous les commerciaux",
    from_date: "Du",
    to_date: "Au",
    reset_filters: "Réinitialiser",
    order_list: "Liste des commandes",
    no_orders: "Aucune commande",

    // Status flow
    status_flow: "Flux de statut",

    // Password
    password: "Mot de passe",
    name: "Nom",
  },

  en: {
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    close: "Close",
    search: "Search",
    actions: "Actions",
    yes: "Yes",
    no: "No",
    logout: "Logout",
    language: "Language",
    login: "Login",
    login_subtitle: "Access your management portal",
    connecting: "Connecting...",
    connect: "Sign in",
    order_management: "Order management and tracking",

    nav_dashboard: "Dashboard",
    nav_orders: "Orders",
    nav_clients: "Clients",
    nav_products: "Products",
    nav_archives: "Archives",
    nav_commercials: "Sales Reps",
    nav_partners: "Partners",
    nav_expenses: "Expenses",
    nav_transport: "Transport",
    nav_settings: "Settings",

    dashboard_title: "Dashboard",
    dashboard_subtitle: "Overview of your activity",
    all_companies: "All companies",
    monthly_sales: "Monthly sales",
    france_vs_vn: "Panther France vs Vietnam",
    total_sales: "Total sales",
    total_costs: "Total costs",
    gross_margin: "Gross margin",
    commissions: "Commissions",
    expenses: "Expenses",
    net_profit: "Net profit",
    orders_in_progress: "Orders in progress",
    no_orders_in_progress: "No orders in progress",
    change_status: "CHANGE STATUS",
    delivery_office: "OFFICE DEL.",
    delivery_client: "CLIENT DEL.",
    order: "Order",
    orders_count: "order(s)",
    client: "Client",
    country: "Country",
    phone: "Phone",
    email: "Email",
    address: "Address",
    company: "Company",
    pieces: "Pieces",
    urgency: "Urgency",
    order_date: "Order date",
    delivery_date_office: "Office delivery",
    delivery_date_client: "Client delivery",
    commercial: "Sales rep",
    commission: "Commission",
    tracking_number: "Tracking #",
    tracking_link: "Tracking link",
    selling_price: "Selling price",
    margin: "Gross margin",
    status: "Status",

    "status_commandée": "ORDERED",
    "status_impression": "PRINTING",
    "status_couture": "SEWING",
    "status_livraison bureau": "OFFICE DELIVERY",
    "status_en cours de livraison client": "CLIENT DELIVERY IN PROGRESS",
    "status_livrée": "DELIVERED",

    urgency_urgent: "Urgent",
    urgency_prioritaire: "Priority",
    urgency_classique: "Standard",
    urgency_non_urgent: "Non urgent",

    month_ca: "Month revenue",
    year_ca: "Year revenue",
    month_commission: "Month commission",
    my_ca_commissions: "My revenue & commissions",
    archives: "Archives",
    delivered_orders_by_month: "Delivered orders by month",

    orders_title: "Orders",
    new_order: "New order",
    order_number: "Order #",
    search_client: "Search by name or company...",
    add_client: "New client",
    firstname: "First name",
    postal_code: "Postal code",
    city: "City",
    delivery_preview: "Delivery date preview",
    order_lines: "Order lines",
    add_line: "Add a line",
    product: "Product",
    quantity: "Quantity",
    unit_cost: "Unit cost",
    weight_kg: "Weight (kg)",
    unit_price: "Unit price",
    subtotal: "Subtotal",
    transport_estimate: "Transport estimate",
    cost_per_kg: "Cost/kg",
    fixed_fee: "Fixed fee",
    total_weight: "Total weight",
    transport_cost: "Transport cost",
    selling_price_eur: "Selling price EUR",
    selling_price_vnd: "Selling price VND",
    profit: "PROFIT",
    sale_minus_product: "Sale - Product",
    sale_minus_all: "Sale - Product - Transport",
    dropbox_link: "Dropbox link",
    save_order: "Save order",
    update_order: "Update",
    required_fields_missing: "Required fields missing",
    images: "Images",
    add_image: "Add image",
    upload_image: "Upload",

    clients_title: "Clients",
    new_client: "New client",
    company_name: "Company",
    total_orders: "Orders",
    total_ca: "Total revenue",

    products_title: "Products",
    new_product: "New product",
    product_name: "Product name",
    cost: "Cost",
    weight: "Weight",

    archives_title: "Archives",
    archives_subtitle: "Delivered orders grouped by month",
    delivered_orders: "delivered order(s)",
    material_cost: "Material cost",
    transport_cost_label: "Transport cost",
    delivery_cost: "Delivery cost",

    commercials_title: "Sales Reps",
    commercials_subtitle: "Manage sales rep accounts and commissions",
    new_commercial: "New sales rep",
    zone: "Coverage zone",
    commission_rate: "Commission rate",
    weekly_recap: "Weekly recap",
    weekly_recap_subtitle: "Performance overview: revenue and commissions by sales rep",
    week_orders: "Week orders",
    week_ca: "Week revenue",
    week_commission: "Week comm.",
    month_orders: "Month orders",
    month_ca_label: "Month revenue",
    month_commission_label: "Month comm.",
    commissions_by_month: "Commissions by month / year",
    commissions_by_month_subtitle: "Auto-calculated commission details for each sales rep",
    months_count: "months",

    partners_title: "Partners",
    partners_subtitle: "Manage partner access (Printer, Sewing, Transport, Manager)",
    new_partner: "New partner",
    partner_type: "Partner type",
    allowed_statuses: "Allowed statuses",
    status_help: "1st status = orders visible, next ones = applicable statuses",

    expenses_title: "Expenses",
    new_expense: "New expense",
    expense_type: "Type",
    amount: "Amount",
    description: "Description",
    currency: "Currency",

    transport_title: "Transport costs",
    transport_subtitle: "Cost management by country",
    add_country: "Add a country",
    monthly_report: "Monthly report - Deliveries",
    monthly_report_subtitle: "Number of delivered orders per month",
    total_delivered: "delivered order(s)",
    delivered_count: "Delivered orders",

    settings_title: "Settings",
    eur_vnd_rate: "EUR/VND rate",

    partner_orders: "Orders to process",
    partner_orders_subtitle: "awaiting your action",
    pending_orders: "pending order(s)",
    no_pending_orders: "No pending orders",
    validate: "VALIDATE",
    weight_label: "Weight (kg)",
    address_delivery: "Delivery address",
    partner_archives: "Archives - Completed tasks",
    partner_archives_subtitle: "processed order(s), grouped by month",
    delivery_expected: "Expected delivery",
    not_provided: "Not provided",

    type_imprimeur: "Printer",
    type_couture: "Sewing",
    type_transport: "Transport",
    type_manager: "Manager",

    manager_title: "Manager Dashboard",
    manager_subtitle: "Track orders in progress",

    click_to_enlarge: "Click to enlarge",
    no_image: "No image",
    image_popup_title: "Order images",

    new_order_notification: "New order!",
    new_orders_notification: "new orders!",
    alert_orange_notification: "Warning: order approaching deadline!",
    alert_red_notification: "Urgent: order overdue!",

    estimated_profit: "ESTIMATED PROFIT",
    product_cost_label: "Product cost",
    product_lines: "product lines",

    filter_by_status: "Filter by status",
    filter_by_date: "Filter by date",
    filter_by_commercial: "Filter by sales rep",
    all_statuses: "All statuses",
    all_commercials: "All sales reps",
    from_date: "From",
    to_date: "To",
    reset_filters: "Reset",
    order_list: "Order list",
    no_orders: "No orders",

    status_flow: "Status flow",

    password: "Password",
    name: "Name",
  },

  vi: {
    loading: "Đang tải...",
    save: "Lưu",
    cancel: "Hủy",
    delete: "Xóa",
    edit: "Sửa",
    create: "Tạo",
    close: "Đóng",
    search: "Tìm kiếm",
    actions: "Hành động",
    yes: "Có",
    no: "Không",
    logout: "Đăng xuất",
    language: "Ngôn ngữ",
    login: "Đăng nhập",
    login_subtitle: "Truy cập cổng quản lý",
    connecting: "Đang kết nối...",
    connect: "Đăng nhập",
    order_management: "Quản lý đơn hàng và theo dõi",

    nav_dashboard: "Bảng điều khiển",
    nav_orders: "Đơn hàng",
    nav_clients: "Khách hàng",
    nav_products: "Sản phẩm",
    nav_archives: "Lưu trữ",
    nav_commercials: "Nhân viên KD",
    nav_partners: "Đối tác",
    nav_expenses: "Chi phí",
    nav_transport: "Vận chuyển",
    nav_settings: "Cài đặt",

    dashboard_title: "Bảng điều khiển",
    dashboard_subtitle: "Tổng quan hoạt động",
    all_companies: "Tất cả công ty",
    monthly_sales: "Doanh thu hàng tháng",
    france_vs_vn: "Panther Pháp vs Việt Nam",
    total_sales: "Tổng doanh thu",
    total_costs: "Tổng chi phí",
    gross_margin: "Lợi nhuận gộp",
    commissions: "Hoa hồng",
    expenses: "Chi phí",
    net_profit: "Lợi nhuận ròng",
    orders_in_progress: "Đơn hàng đang xử lý",
    no_orders_in_progress: "Không có đơn hàng đang xử lý",
    change_status: "ĐỔI TRẠNG THÁI",
    delivery_office: "GIAO VĂN PHÒNG",
    delivery_client: "GIAO KHÁCH",
    order: "Đơn hàng",
    orders_count: "đơn hàng",
    client: "Khách hàng",
    country: "Quốc gia",
    phone: "Điện thoại",
    email: "Email",
    address: "Địa chỉ",
    company: "Công ty",
    pieces: "Số lượng",
    urgency: "Độ gấp",
    order_date: "Ngày đặt hàng",
    delivery_date_office: "Giao văn phòng",
    delivery_date_client: "Giao khách hàng",
    commercial: "Nhân viên KD",
    commission: "Hoa hồng",
    tracking_number: "Mã vận đơn",
    tracking_link: "Link theo dõi",
    selling_price: "Giá bán",
    margin: "Lợi nhuận gộp",
    status: "Trạng thái",

    "status_commandée": "ĐÃ ĐẶT HÀNG",
    "status_impression": "ĐANG IN",
    "status_couture": "ĐANG MAY",
    "status_livraison bureau": "GIAO VĂN PHÒNG",
    "status_en cours de livraison client": "ĐANG GIAO CHO KHÁCH",
    "status_livrée": "ĐÃ GIAO",

    urgency_urgent: "Gấp",
    urgency_prioritaire: "Ưu tiên",
    urgency_classique: "Bình thường",
    urgency_non_urgent: "Không gấp",

    month_ca: "Doanh thu tháng",
    year_ca: "Doanh thu năm",
    month_commission: "Hoa hồng tháng",
    my_ca_commissions: "Doanh thu & hoa hồng",
    archives: "Lưu trữ",
    delivered_orders_by_month: "Đơn đã giao theo tháng",

    orders_title: "Đơn hàng",
    new_order: "Đơn hàng mới",
    order_number: "Mã đơn hàng",
    search_client: "Tìm theo tên hoặc công ty...",
    add_client: "Khách hàng mới",
    firstname: "Tên",
    postal_code: "Mã bưu điện",
    city: "Thành phố",
    delivery_preview: "Xem trước ngày giao",
    order_lines: "Dòng đơn hàng",
    add_line: "Thêm dòng",
    product: "Sản phẩm",
    quantity: "Số lượng",
    unit_cost: "Giá gốc",
    weight_kg: "Trọng lượng (kg)",
    unit_price: "Đơn giá",
    subtotal: "Thành tiền",
    transport_estimate: "Ước tính vận chuyển",
    cost_per_kg: "Phí/kg",
    fixed_fee: "Phí cố định",
    total_weight: "Tổng trọng lượng",
    transport_cost: "Phí vận chuyển",
    selling_price_eur: "Giá bán EUR",
    selling_price_vnd: "Giá bán VND",
    profit: "LỢI NHUẬN",
    sale_minus_product: "Bán - Sản phẩm",
    sale_minus_all: "Bán - Sản phẩm - Vận chuyển",
    dropbox_link: "Link Dropbox",
    save_order: "Lưu đơn hàng",
    update_order: "Cập nhật",
    required_fields_missing: "Thiếu các trường bắt buộc",
    images: "Hình ảnh",
    add_image: "Thêm hình",
    upload_image: "Tải lên",

    clients_title: "Khách hàng",
    new_client: "Khách hàng mới",
    company_name: "Công ty",
    total_orders: "Đơn hàng",
    total_ca: "Tổng doanh thu",

    products_title: "Sản phẩm",
    new_product: "Sản phẩm mới",
    product_name: "Tên sản phẩm",
    cost: "Giá gốc",
    weight: "Trọng lượng",

    archives_title: "Lưu trữ",
    archives_subtitle: "Đơn hàng đã giao theo tháng",
    delivered_orders: "đơn đã giao",
    material_cost: "Giá nguyên liệu",
    transport_cost_label: "Phí vận chuyển",
    delivery_cost: "Phí giao hàng",

    commercials_title: "Nhân viên KD",
    commercials_subtitle: "Quản lý tài khoản và hoa hồng",
    new_commercial: "Nhân viên KD mới",
    zone: "Khu vực",
    commission_rate: "Tỷ lệ hoa hồng",
    weekly_recap: "Tổng kết tuần",
    weekly_recap_subtitle: "Tổng quan hiệu suất: doanh thu và hoa hồng",
    week_orders: "ĐH tuần",
    week_ca: "DT tuần",
    week_commission: "HH tuần",
    month_orders: "ĐH tháng",
    month_ca_label: "DT tháng",
    month_commission_label: "HH tháng",
    commissions_by_month: "Hoa hồng theo tháng / năm",
    commissions_by_month_subtitle: "Chi tiết hoa hồng tự động cho từng nhân viên KD",
    months_count: "tháng",

    partners_title: "Đối tác",
    partners_subtitle: "Quản lý quyền truy cập (In ấn, May, Vận chuyển, Quản lý)",
    new_partner: "Đối tác mới",
    partner_type: "Loại đối tác",
    allowed_statuses: "Trạng thái được phép",
    status_help: "Trạng thái 1 = đơn hàng hiển thị, các trạng thái sau = có thể áp dụng",

    expenses_title: "Chi phí",
    new_expense: "Chi phí mới",
    expense_type: "Loại",
    amount: "Số tiền",
    description: "Mô tả",
    currency: "Tiền tệ",

    transport_title: "Chi phí vận chuyển",
    transport_subtitle: "Quản lý chi phí theo quốc gia",
    add_country: "Thêm quốc gia",
    monthly_report: "Báo cáo tháng - Giao hàng",
    monthly_report_subtitle: "Số đơn hàng đã giao theo tháng",
    total_delivered: "đơn đã giao",
    delivered_count: "Đơn đã giao",

    settings_title: "Cài đặt",
    eur_vnd_rate: "Tỷ giá EUR/VND",

    partner_orders: "Đơn hàng cần xử lý",
    partner_orders_subtitle: "đang chờ xử lý",
    pending_orders: "đơn hàng chờ xử lý",
    no_pending_orders: "Không có đơn hàng chờ xử lý",
    validate: "XÁC NHẬN",
    weight_label: "Trọng lượng (kg)",
    address_delivery: "Địa chỉ giao hàng",
    partner_archives: "Lưu trữ - Công việc hoàn thành",
    partner_archives_subtitle: "đơn đã xử lý, theo tháng",
    delivery_expected: "Dự kiến giao",
    not_provided: "Chưa cung cấp",

    type_imprimeur: "In ấn",
    type_couture: "May",
    type_transport: "Vận chuyển",
    type_manager: "Quản lý",

    manager_title: "Bảng điều khiển Quản lý",
    manager_subtitle: "Theo dõi đơn hàng đang xử lý",

    click_to_enlarge: "Nhấn để phóng to",
    no_image: "Không có hình",
    image_popup_title: "Hình ảnh đơn hàng",

    new_order_notification: "Đơn hàng mới!",
    new_orders_notification: "đơn hàng mới!",
    alert_orange_notification: "Cảnh báo: đơn hàng sắp đến hạn!",
    alert_red_notification: "Khẩn cấp: đơn hàng quá hạn!",

    estimated_profit: "LỢI NHUẬN ƯỚC TÍNH",
    product_cost_label: "Giá sản phẩm",
    product_lines: "dòng sản phẩm",

    filter_by_status: "Lọc theo trạng thái",
    filter_by_date: "Lọc theo ngày",
    filter_by_commercial: "Lọc theo NV kinh doanh",
    all_statuses: "Tất cả trạng thái",
    all_commercials: "Tất cả NV kinh doanh",
    from_date: "Từ",
    to_date: "Đến",
    reset_filters: "Đặt lại",
    order_list: "Danh sách đơn hàng",
    no_orders: "Không có đơn hàng",

    status_flow: "Luồng trạng thái",

    password: "Mật khẩu",
    name: "Tên",
  }
};

// Helper: translate a status string
export const translateStatus = (status, t) => {
  const key = `status_${status}`;
  const translated = t(key);
  return translated !== key ? translated : status.toUpperCase();
};

// Helper: translate urgency
export const translateUrgency = (urgency, t) => {
  const map = { 'urgent': 'urgency_urgent', 'prioritaire': 'urgency_prioritaire', 'classique': 'urgency_classique', 'non urgent': 'urgency_non_urgent' };
  const key = map[urgency];
  return key ? t(key) : urgency;
};

// Helper: translate partner type
export const translatePartnerType = (type, t) => {
  const key = `type_${type}`;
  const translated = t(key);
  return translated !== key ? translated : type;
};

export default translations;
